'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = require('../constants');

var _util = require('../util');

exports.default = _extends({}, (0, _util.createActionObject)('createRequest', _constants.BOOKING_REQUEST_CREATE_START, _constants.BOOKING_REQUEST_CREATE_SUCCESS, _constants.BOOKING_REQUEST_CREATE_FAILURE), (0, _util.createActionObject)('loadBookingAvailability', _constants.LOAD_BOOKING_AVAILABILITY_START, _constants.LOAD_BOOKING_AVAILABILITY_SUCCESS, _constants.LOAD_BOOKING_AVAILABILITY_FAILURE));


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/~/@arreeba/ristoranti-lib/lib/action/booking.js
// module id = 420
// module chunks = 0